import { render, staticRenderFns } from "./NotificationSettings.vue?vue&type=template&id=5231f5e2&"
import script from "./NotificationSettings.vue?vue&type=script&lang=ts&"
export * from "./NotificationSettings.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationSettings.vue?vue&type=style&index=0&postcss=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VDataTable})
